import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-background-50">
      {/* Background product texture overlay */}
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Artistic%20overhead%20arrangement%20of%20diverse%20fashion%20accessories%20including%20tortoiseshell%20sunglasses%20a%20brown%20leather%20belt%20coiled%20elegantly%20a%20minimalist%20canvas%20tote%20and%20a%20delicate%20gold%20chain%20necklace%20scattered%20organically%20on%20a%20warm%20sand%20colored%20concrete%20surface%20with%20gentle%20side%20lighting%20creating%20elongated%20shadows%20editorial%20product%20photography%20clean%20minimal%20aesthetic%20warm%20earthy%20tones%20high%20detail&width=1600&height=1200&seq=hero-texture-v2&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/80 via-transparent to-background-50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-[72px] pb-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left Column */}
          <div className="lg:w-[35%] flex flex-col">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 leading-[1.15]">
              Superbuy Spreadsheet
              <br />
              <span className="text-primary-500">The Ultimate</span>
              <br />
              Resource Hub 2026
            </h1>
            <p className="mt-6 text-foreground-600 text-base md:text-lg leading-relaxed max-w-md">
              Organized product research, curated finds, and direct links to the best Superbuy spreadsheet resources. Discover trending items across shoes, clothing, accessories, and more — all in one place.
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mt-8">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 font-label font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Superbuy Sheet
                <i className="ri-arrow-right-up-line text-base"></i>
              </a>
              <Link
                to="/articles/superbuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-7 py-3.5 border-2 border-foreground-200 text-foreground-700 font-label font-semibold text-sm rounded-full hover:border-foreground-400 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read the Guide
                <i className="ri-arrow-right-line text-base"></i>
              </Link>
            </div>
            <p className="mt-6 text-foreground-400 text-xs font-label">
              <i className="ri-shield-check-line mr-1"></i>
              Independent Resource &bull; Updated 2026 &bull; Beginner Friendly
            </p>
          </div>

          {/* Center Column - Hero Image */}
          <div className="lg:w-[35%] flex justify-center">
            <div className="w-full max-w-[420px] aspect-[3/4] rounded-3xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20vertical%20editorial%20flat%20lay%20featuring%20a%20pair%20of%20warm%20cognac%20leather%20loafers%20beside%20a%20neatly%20folded%20charcoal%20merino%20wool%20sweater%20and%20a%20polished%20rose%20gold%20toned%20wristwatch%20arranged%20gracefully%20on%20a%20cream%20linen%20surface%20with%20a%20sprig%20of%20dried%20lavender%20soft%20morning%20light%20from%20a%20nearby%20window%20creating%20a%20gentle%20atmospheric%20glow%20refined%20product%20photography%20warm%20neutral%20palette%20organic%20textures%20luxurious%20yet%20understated&width=840&height=1120&seq=hero-portrait-v2&orientation=portrait"
                alt="Curated Superbuy Spreadsheet product finds featuring premium sneakers, clothing, and accessories"
                title="Superbuy Spreadsheet Product Finds"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right Column */}
          <div className="lg:w-[30%]">
            <div className="flex items-center gap-2 mb-5">
              <h2 className="font-heading text-lg font-semibold text-foreground-950">
                Trending Categories
              </h2>
              <i className="ri-arrow-right-up-line text-primary-500 text-lg"></i>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <a
                href="https://kaspreadsheet.com/search-917/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="col-span-2 relative aspect-square rounded-2xl overflow-hidden bg-background-100 group cursor-pointer"
              >
                <img
                  src="https://readdy.ai/api/search-image?query=Matching%20coordinated%20two%20piece%20lounge%20set%20in%20soft%20sage%20green%20tone%20neatly%20folded%20on%20a%20light%20oak%20surface%20with%20a%20steaming%20ceramic%20tea%20cup%20nearby%20soft%20diffused%20morning%20light%20filtering%20through%20sheer%20curtains%20minimalist%20lifestyle%20product%20photography%20clean%20composition%20calming%20aesthetic%20elevated%20everyday%20style&width=600&height=600&seq=hero-sets-v2&orientation=squarish"
                  alt="Matching Sets category"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute bottom-3 left-3 px-3 py-1 bg-white/90 backdrop-blur-sm rounded-lg text-xs font-label font-semibold text-foreground-800">
                  Sets
                </span>
              </a>
              <a
                href="https://kaspreadsheet.com/category-911-Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="relative aspect-square rounded-2xl overflow-hidden bg-background-100 group cursor-pointer"
              >
                <img
                  src="https://readdy.ai/api/search-image?query=Single%20elegant%20pair%20of%20dark%20brown%20leather%20Chelsea%20boots%20with%20polished%20finish%20standing%20on%20a%20textured%20stone%20surface%20with%20subtle%20moss%20growth%20warm%20golden%20hour%20sunlight%20casting%20dramatic%20shadows%20product%20photography%20rich%20tones%20sophisticated%20aesthetic%20refined%20composition&width=400&height=400&seq=hero-shoes-v2&orientation=squarish"
                  alt="Shoes category"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute bottom-2 left-2 px-2.5 py-1 bg-white/90 backdrop-blur-sm rounded-lg text-xs font-label font-semibold text-foreground-800">
                  Shoes
                </span>
              </a>
              <a
                href="https://kaspreadsheet.com/search-912/name/Shoes.html"
                target="_blank"
                rel="noopener nofollow"
                className="relative aspect-square rounded-2xl overflow-hidden bg-background-100 group cursor-pointer"
              >
                <img
                  src="https://readdy.ai/api/search-image?query=Beautifully%20draped%20dusty%20rose%20pink%20cashmere%20blend%20cardigan%20with%20delicate%20wooden%20buttons%20laid%20flat%20on%20a%20soft%20white%20textured%20throw%20blanket%20gentle%20window%20light%20creating%20soft%20pastel%20tones%20and%20subtle%20fabric%20texture%20detail%20editorial%20product%20photography%20feminine%20aesthetic%20cozy%20refined%20warmth&width=400&height=400&seq=hero-hoodies-v2&orientation=squarish"
                  alt="Hoodies category"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute bottom-2 left-2 px-2.5 py-1 bg-white/90 backdrop-blur-sm rounded-lg text-xs font-label font-semibold text-foreground-800">
                  Hoodies
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}